import { CounterType } from "definitions/counter-api";

import { RateCardProps } from "./components";

export const rates: RateCardProps[] = [
  {
    type: "free",
    title: "Бесплатный тариф",
    badge: "Бесплатно",
    badgeTheme: "warning",
    description: "Для небольших проектов",
    price: "Бесплатно",
    button: {
      type: "demo",
      title: "Попробовать",
      hint: "Без необходимости оплаты",
    },
    trial: false,
    features: [
      {
        title: "Панель управления",
        description: "Удобный интерфейс для управления",
      },
      {
        title: "Доступ к базе товаров",
        description: "Базовая информация о товарах, категориях и брендах",
      },
      {
        title: "Доступ к документации API",
        description: "Полная техническая документация для разработчиков",
      },
      {
        title: "Доступ к созданию выборок",
        description: "Возможность создавать выборки товаров",
      },
      {
        title: "Поддержка в стандартной очереди",
        description: "Ответ в течение 24 часов в рабочее время",
      },
    ],
  },
  {
    type: "base",
    title: "Базовый тариф",
    description: "Для первоначального ознакомления с сервисом",
    price: "10 900 ₽ / Месяц",
    button: { type: "action", title: "Приобрести" },
    trial: true,
    featuresAfterTitle: "Все из Бесплатного, а также:",
    features: [
      {
        title: "1 запрос в секунду",
        description: "Ограничение до 1-го одновременного запроса к API",
      },
      {
        title: "10 000 запросов в месяц",
        description: "Ограничение до 10 тысяч API запросов ежемесячно",
      },
      {
        title: "Панель управления",
        description: "Расширенная панель с дополнительными инструментами",
      },
      {
        title: "Доступ к выгрузке товаров",
        description: "Экспорт данных в различных форматах",
      },
      {
        title: "Поддержка в стандартной очереди",
        description: "Ответ в течение 24 часов в рабочее время",
      },
    ],
    meta: {
      type: CounterType.AllSourcesRequests,
      rps: 1,
      req: 10_000,
      withExport: true,
      time: "30 days",
    },
  },
  {
    type: "standard",
    title: "Стандартный тариф",
    badge: "Популярный",
    description: "Отлично подходит для небольших команд",
    price: "21 900 ₽ / Месяц",
    button: { type: "action", title: "Приобрести" },
    trial: true,
    featuresAfterTitle: "Все из Базового, а также:",
    features: [
      {
        title: "1 запрос в секунду",
        description: "Ограничение до 1-го одновременного запроса к API",
      },
      {
        title: "30 000 запросов в месяц",
        description: "Ограничение до 30 тысяч API запросов ежемесячно",
      },
      {
        title: "Панель управления",
        description: "Расширенная панель с дополнительными инструментами",
      },
      {
        title: "Доступ к выгрузке товаров",
        description: "Экспорт данных в различных форматах",
      },
      {
        title: "Поддержка в стандартной очереди",
        description: "Ответ в течение 24 часов в рабочее время",
      },
    ],
    meta: {
      type: CounterType.DewuRequests,
      rps: 1,
      req: 30_000,
      withExport: true,
      time: "30 days",
    },
  },
  {
    type: "pro",
    title: "Профессиональный тариф",
    description: "Отлично подходит для небольших команд",
    price: "34 900 ₽ / Месяц",
    button: { type: "action", title: "Приобрести" },
    trial: true,
    featuresAfterTitle: "Все из Стандартного, а также:",
    features: [
      {
        title: "2 запроса в секунду",
        description: "Ограничение до 2-х одновременных запросов к API",
      },
      {
        title: "100 000 запросов в месяц",
        description: "Ограничение до 100 тысяч API запросов ежемесячно",
      },
      {
        title: "Доступ к отслеживанию заказов",
        description: "Мониторинг статусов заказов в реальном времени",
      },
      {
        title: "Доступ к трансформациям",
        description: "Преобразование данных в выгрузках под ваши потребности",
      },
      {
        title: "Приоритетная поддержка",
        description: "Ответ примерно в течение 4 часов в рабочее время",
      },
    ],
    meta: {
      type: CounterType.DewuRequests,
      rps: 2,
      req: 100_000,
      withExport: true,
      time: "30 days",
    },
  },
];
